import { Button, Grid, TextField, Box, Typography, Paper, Divider, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import Attribute from "./Attribute";
import AnnonceContext from "../../../contexts/AnnonceContext";
import Upload from "../publier/FormComponents/Forms/upload";
import { updateAnnonce, updateAnnonceImage } from "../../../service/annonceApi";
import { notifySuccess } from "src/service/notificationService";
import { styled } from '@mui/material/styles';

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.1rem',
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(2),
}));

const FormSection = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
}));

export default function UpdateAds({ selectedAnnonce, setSelectedAnnonce, userToken = "", categories, updateUserAds }) {

    const [imageUpload, setImageUpload] = useState();
    const [currentCategory, setCurrentCategory] = useState(null);
    const [formAttributes, setFormAttributes] = useState([]);
    const [date, setDate] = useState();
    const [formAnnonce, setFormAnnonce] = useState({
      id: selectedAnnonce.id,
      origin: selectedAnnonce.origin,
      status: selectedAnnonce.status,
      ville: selectedAnnonce.ville,
      details: selectedAnnonce.details,
    });

    const [isComplete, setIsComplete] = useState(false);

    const handleSubmit = async () => {
      updateAnnonce(formAnnonce.id, formAnnonce)
      .then((response) => {
        const ads = response
        const annonceId = response.id;
        ads.annonceAttributes = Object.values(ads.annonceAttributes)
        updateUserAds(ads)
        setSelectedAnnonce(ads)
        notifySuccess('Annonce mise à jour avec succès');
        updateAnnonceImage(annonceId, imageUpload)
      });
    }

    const setAnnonceAttributes = () => {
      const annonceAttributes = selectedAnnonce.annonceAttributes;
      const formAttributes = annonceAttributes.map((attribute) => {
        if (!attribute.uiType)
          attribute.uiType = "";
        return attribute;
      }
      );
      setFormAttributes(formAttributes);
    }

    useEffect(() => {
      const category = categories.find((category) => {
        return category.id === selectedAnnonce.category.id;
      })
      setCurrentCategory(category)
      setAnnonceAttributes()
    }, []);

    useEffect(() => {
      setFormAnnonce({
        ...formAnnonce,
        annonceAttributes: formAttributes,
      });
    }, [formAttributes]);

  const isMobile = useMediaQuery('(max-width:900px)');

  return (
    <Box sx={{ p: 3, pb: isMobile ? '80px' : 0, display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Grid container spacing={3}>
        {currentCategory && (
          <Grid item xs={12} sx={{ pb: isMobile ? '90px' : 0 }}>
            <AnnonceContext.Provider
                value={{
                  formAnnonce: formAnnonce,
                  setFormAnnonce: setFormAnnonce,
                  currentCategory: currentCategory,
                  setCurrentCategory: setCurrentCategory,
                  formAttributes: formAttributes,
                  setFormAttributes: setFormAttributes,
                  handleSubmit: handleSubmit,
                  imageUpload: imageUpload,
                  setImageUpload: setImageUpload,
                  date: date,
                  setDate: setDate,
                  isComplete: isComplete,
                  setIsComplete: setIsComplete,
                }}
            >
              <FormSection>
                <SectionTitle>Informations publiques</SectionTitle>
                <Box sx={{ mb: 3 }}>
              <Attribute isSecret={false} selectedAnnonce={selectedAnnonce}/>
                </Box>
              </FormSection>

              <FormSection>
                <SectionTitle>Informations confidentielles</SectionTitle>
                <Box sx={{ mb: 3 }}>
              <Attribute isSecret={true} selectedAnnonce={selectedAnnonce}/>
                </Box>
              </FormSection>

              <FormSection>
                <SectionTitle>Photos</SectionTitle>
                <Box sx={{ mb: 3 }}>
              <Upload />
                </Box>
              </FormSection>

              <FormSection>
                <SectionTitle>Détails supplémentaires</SectionTitle>
              <TextField
                  fullWidth
                  id="outlined-multiline-flexible"
                  label="Détails"
                  multiline
                  maxRows={4}
                  value={formAnnonce ? formAnnonce.details : ""}
                  onChange={(e) =>
                      setFormAnnonce({ ...formAnnonce, details: e.target.value })
                  }
                  sx={{ mb: 3 }}
              />
              </FormSection>

              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <Button 
                  variant="contained" 
                  color="primary" 
                  onClick={handleSubmit}
                  size="large"
                  sx={{ 
                    px: 4,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: 'none',
                    fontSize: '1rem'
                  }}
                >
                    Mettre à jour votre annonce
                  </Button>
              </Box>
            </AnnonceContext.Provider>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
